var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    viewBox: "0 0 39 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.692 4.95536C21.4554 4.48661 21.9643 3.63616 21.9643 2.67857C21.9643 1.19866 20.7656 0 19.2857 0C17.8058 0 16.6071 1.19866 16.6071 2.67857C16.6071 3.64286 17.1161 4.48661 17.8795 4.95536L14.0424 12.6295C13.433 13.8482 11.8527 14.1964 10.7879 13.346L4.82143 8.57143C5.15625 8.12277 5.35714 7.56696 5.35714 6.96429C5.35714 5.48437 4.15848 4.28571 2.67857 4.28571C1.19866 4.28571 0 5.48437 0 6.96429C0 8.4442 1.19866 9.64286 2.67857 9.64286C2.69196 9.64286 2.71205 9.64286 2.72545 9.64286L5.78571 26.4777C6.15402 28.5134 7.92857 30 10.0045 30H28.567C30.6362 30 32.4107 28.5201 32.7857 26.4777L35.846 9.64286C35.8594 9.64286 35.8795 9.64286 35.8929 9.64286C37.3728 9.64286 38.5714 8.4442 38.5714 6.96429C38.5714 5.48437 37.3728 4.28571 35.8929 4.28571C34.4129 4.28571 33.2143 5.48437 33.2143 6.96429C33.2143 7.56696 33.4152 8.12277 33.75 8.57143L27.7835 13.346C26.7188 14.1964 25.1384 13.8482 24.529 12.6295L20.692 4.95536Z",
    fill: "#FFCD05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownyellow);
export default __webpack_public_path__ + "static/media/crown yellow.2dbac4e18cdb754f82edba956b684607.svg";
export { ForwardRef as ReactComponent };